import { SubComponentProps } from '../EventFormField.types';
import { QHeading } from '@qualio/ui-components';

const SectionField = ({ label, children }: SubComponentProps) => {
  return (
    <QHeading data-cy="section-field" size="md">
      {label} {children}
    </QHeading>
  );
};

export default SectionField;
